<template>
    <div>
        <div class="row">
            <div class="col">
                <p>Below are all your recent transactions and payments that have been made to Servers Australia. If you believe that there has been an error, please just <a href="/support/conversations">get in touch</a> and we can resolve this for you.</p>
            </div>
        </div>
        <sau-template :retrieved="requestFinished">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Transactions</template>
            <!-- Data -->
            <template slot="data">
                <table v-if="Object.keys(transactions).length > 0" id="data-table-transactions"  data-sort="[5]" class="table table-hover data-table" data-empty="No Transactions" data-search="Search" cellspacing="0" width="100%" style="display:none;">
                    <thead class="d-none">
                        <tr>
                            <th>Details</th>
                            <th class="noshow">ID</th>
                            <th class="noshow">Transaction ID</th>
                            <th class="noshow">Description</th>
                            <th class="noshow">Payment Method</th>
                            <th class="noshow">Date</th>
                            <th class="noshow">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td>
                                <a :href="invoiceLink(transaction.invoiceid)">
                                    <div class="d-flex product-list">
                                        <div>
                                            <i class="product-icons pr-6 pt-2 fal fa-file-invoice-dollar" aria-hidden="true"></i>
                                        </div>
                                        <div>
                                            <p class="product-name">Payment - Invoice No: {{transaction.invoiceid}}</p>
                                            <p class="product-desc"><span class="sau-font-bold">Payment Method: </span>{{ getPaymentMethod(transaction.gateway) }}</p>
                                            <p class="product-desc"><span class="sau-font-bold">Transaction Date: </span>{{ transaction.date | moment('DD/MM/YYYY') }}</p>
                                            <p class="product-desc"><span class="sau-font-bold">Amount: </span>{{ getPaymentAmount(transaction) | currency }}</p>
                                        </div>
                                    </div>
                                </a>
                            </td>
                            <td :data-filter="applyFilter('id', transaction.invoiceid)">{{ transaction.invoiceid }}</td>
                            <td :data-filter="applyFilter('transaction-id', transaction.transid)">{{ transaction.transid }}</td>
                            <td :data-filter="applyFilter('description',transaction.description)">Payment - Invoice No: {{transaction.invoiceid}}</td>
                            <td :data-filter="applyFilter('payment-method',transaction.gateway)">{{ getPaymentMethod(transaction.gateway) }}</td>
                            <td :data-filter="applyFilter('date',transaction.date)" :data-order="convertDate(transaction.date)">{{ transaction.date | moment('DD/MM/YYYY') }}</td>
                            <td :data-filter="applyFilter('amount', transaction)" class="text-right">{{ getPaymentAmount(transaction) | currency }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>

                    <sau-apiro-response type="message">
                        <template slot="message">You don't have any transactions at the moment.</template>
                    </sau-apiro-response>

                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            transactions: [],
            paymentMethods: [],
            requestFinished: false
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getTransactions().then(response => {

                this.transactions = response.data;
                if(this.transactions) {
                    this.$nextTick(() => {
                        this.initializeDataTables();
                    });
                }
                this.requestFinished = true;
            }).catch(error => {
                this.requestFinished = true;
            })

            this.getPaymentMethods().then(response => {
                this.paymentMethods = response.data
            })
        },
        getPaymentAmount(transaction) {
            return transaction.amountin > 0 ? transaction.amountin : transaction.amountout;
        },
        invoiceLink(invoiceid) {
            return '/billing/invoices/'+invoiceid;
        },
        applyFilter(column, data) {
            if(column == 'date') {
                data = moment(data).format('DD/MM/YYYY')
            } else if (column == 'amount') {
                data = data.amountin > 1 ? data.amountin : data.amountout;
            }
            return column+":"+data;
        },
        convertDate(date) {
            return Date.parse(date);
        },
        getPaymentMethod(gateway){
            var method = this.paymentMethods.find(function(value){ return value.key == gateway})
            return method ? method.value : null;
        }
    },
}
</script>
<style>
    .product-list i.product-icons {
        font-size:4rem;
        margin: 10px auto;
    }
    #data-table-transactions a {
        color:#666;
        text-decoration: none;
    }
</style>
